import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import { useRef, useCallback } from "react";
import VersatileLink from "@/components/VersatileLink.js";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";

export default function TVShowCard(props) {
  const { item, intersect, slider, ...props_ } = props;
  const cardRef = useRef();
  const { classNames } = useSliderPosition(props_, cardRef);
  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      ref={cardRef}
      className={classnames(classNames, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <VersatileLink onClick={handleClick} href={routes.titleWithRtsid(item)}>
        <div>
          <CardArtwork
            item={item}
            intersect={intersect}
            showValuePlanLabel={showValuePlanLabel}
          />
          <div className={styles.infoContainer}>
            <div className={styles.info}>
              <div className={styles.title}>
                <p>{item.name}</p>
              </div>
              <div className={styles.genre}>
                <span>{item.genres.map((genre) => genre.name).join("/")}</span>
              </div>
            </div>
            <div className={`${styles.feature}`}>
              {props_.focusIndex != null && (
                <>
                  <div className={styles.title}>
                    <p>{item.name}</p>
                  </div>
                  <div className={styles.episodes}>
                    <span>
                      {item.genres.map((genre) => genre.name).join("/")}
                    </span>
                  </div>
                  <div className={styles.description}>
                    <p>{item.description}</p>
                  </div>
                  <div className={styles.other}>
                    <span></span>
                    <FavoriteButton
                      metaId={item.id}
                      className={styles.favorite}
                      fillGray
                      scale
                      text="お気に入り"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </VersatileLink>
    </div>
  );
}
